import Cookies from 'js-cookie';
import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import { AdminContext } from 'context/AdminContext';
import LoginService from 'services/LoginService';
import { notifyError, notifySuccess } from 'utils/toast';

const useLoginSubmit = () => {
	const [loading, setLoading] = useState(false);
	const { dispatch } = useContext(AdminContext);
	const history = useHistory();
	const location = useLocation();
	const {
		register,
		handleSubmit,
		trigger,
       setValue, 
       formState: { errors },
  } = useForm();

  const onSubmit = async (data, rememberMe = false) => {
	
	setLoading(true);
  
	if (rememberMe) {
	  localStorage.setItem("rememberMe", "true");
	  localStorage.setItem("userEmail", data.email); 
	  localStorage.setItem("userPassword", data.password); 
	} else {
	  localStorage.removeItem("rememberMe");
	  localStorage.removeItem("userEmail");
	  localStorage.removeItem("userPassword"); 
	}
  
	const cookieTimeOut = 0.5; 
  
	if (location.pathname === "/login") {
		LoginService.loginEmployee({ email: data.email, password: data.password })
		.then((res) => {
		  setLoading(false);
		  if (res.status === true) {
			notifySuccess("Login Success!");
			dispatch({ type: "USER_LOGIN", payload: res.data });
			Cookies.set("adminInfo", JSON.stringify(res.data), {
			  expires: cookieTimeOut,
			});
			localStorage.setItem("adminInfo", JSON.stringify(res.data));
  
			// Handle localStorage based on rememberMe
			if (rememberMe) {
			  localStorage.setItem("userEmail", data.email);
			  localStorage.setItem("userPassword", data.password); // Save password in localStorage
			} else {
			  localStorage.removeItem("userEmail");
			  localStorage.removeItem("userPassword");
			}
  
			history.replace("/");
		  } else {
			notifyError(res.message);
		  }
		})
		.catch((err) => {
		  notifyError(err ? err.response.data.message : err.message);
		  setLoading(false);
		});
	}

    if (location.pathname === "/signup") {
      // Use data.email and data.password for signup
      LoginService.registerAdmin({ email: data.email, password: data.password })
        .then((res) => {
          setLoading(false);
          notifySuccess("Register Success!");
          dispatch({ type: "USER_LOGIN", payload: res });
          Cookies.set("adminInfo", JSON.stringify(res), {
            expires: cookieTimeOut,
          });
          history.replace("/");
        })
        .catch((err) => {
          notifyError(err ? err.response.data.message : err.message);
          setLoading(false);
        });
    }

    if (location.pathname === "/forgot-password") {
      // Handle forgot password
      LoginService.forgetPassword({ verifyEmail: data.email })
        .then((res) => {
          setLoading(false);
          notifySuccess(res.message);
        })
        .catch((err) => {
          setLoading(false);
          notifyError(err ? err.response.data.message : err.message);
        });
    }
  };

  return {
    onSubmit,
    register,
    handleSubmit,
    trigger,
	setValue, // Add setValue here
    errors,
    loading,
  };
};

export default useLoginSubmit;
